let pubulicParams = {
  name: '公共参数',
  updateTime: '2020-05-26 10:00:00',
  methods: 'post',
  request: [{
    params: 'appId',
    type: "String",
    required: true,
    length: 32,
    description: {
      text: '油柑网分配给开发者的应用 ID',
      value: []
    },
    example: '123456'
  }, {
    params: 'method',
    type: "String",
    required: true,
    length: 100,
    description: {
      text: 'ygw.api.order.create',
      value: []
    },
    example: '123456'
  }, {
    params: 'sign',
    type: "String",
    required: true,
    length: 32,
    description: {
      text: '签名',
      value: []
    },
    example: 'md5值'
  }, {
    params: 'params',
    type: "String",
    required: true,
    length: '不限',
    description: {
      text: '请求参数的集合，最大长度不限，除公共参数外所有请求参 数都必须放在这个参数中传递，具体参照各产品快速接入文档',
      value: []
    },
    example: '{"name":"油柑网","id":"2"}'
  }]
}

export default pubulicParams;